import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {  //用于存放数据
        dataSource:[],
        token:'',
        userInfo:{},
        newsList:[],//新闻
        policyList:[],//政策
        nqiList:[],//nqi
        enterList:[],//企业名录
        datasource:[],//数据字典
    },
    mutations: { //同步的更改数据
        DATA_SOURCE(state,newVal){
            state.dataSource=newVal
        },
        // token
        TOKEN(state,newVal){
            
            state.token=newVal;
        },
        // 登录获取个人信息
        USERINFO(state,newVal){
            state.userInfo=newVal;
        },
        // 菜单
        // 新闻分类
        NEWSLIST(state,newVal){
            state.newsList=newVal;
        },
        // 政策
        POLICYLIST(state,newVal){
            state.policyList=newVal;
        },
        // nqi
        NQILIST(state,newVal){
            state.nqiList=newVal;
        },
        // 企业名录
        ENTERLIST(state,newVal){
            state.enterList=newVal;
        },
        // 数据字典
        DATESOURCE(state,newVal){
            state.datasource =newVal;
        },
    },
    actions: {//可异步的更改数据
    //   incrementCount (context) {
    //     context.commit('incrementCount ')
    //   }
    }})
    export default store
